import {
    actionFailure,
    createActionHandler,
} from 'src/modules/assistant/actions/createActionHandler';
import { TSendTemplateDraft } from 'src/modules/assistant/actions/types';
import { getLeadStoreArea } from 'src/modules/assistant/helpers/getLeadStoreArea';
import { isChannelsModeArea } from 'src/modules/conversations/channels';
import { sendChannelTemplate } from './sendChannelTemplate';
import { sendLegacyTemplate } from './sendLegacyTemplate';

export const sendTemplate = createActionHandler<TSendTemplateDraft>({
    validate: (draft) => Boolean(draft.templateId),
    execute: (draft, deps) => {
        if (!deps.channel.canSendTemplate)
            return actionFailure(deps.channel.templateBlockReason);
        const send = isChannelsModeArea(getLeadStoreArea(deps.lead))
            ? sendChannelTemplate
            : sendLegacyTemplate;
        return send(draft, deps);
    },
});
